'use client';

import { Button, useRequest } from '@wk/wk-uni-lib';
import { redirect, usePathname, useSearchParams } from 'next/navigation';

import { useLanguage } from '@/hooks/use-language';
import { getLanguage } from '@/utils/dictionary';
import ErrorBg from 'public/images/common/error.svg';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { currentLanguage } = useLanguage();
  const { message: errorMessage } = error || {};
  const params = Promise.resolve({ lang: currentLanguage });
  const { data: dictionary } = useRequest(() => getLanguage(params, 'common'), {
    refreshDeps: [currentLanguage],
  });

  if (
    (errorMessage === '未授权访问' || errorMessage === 'Unauthorized access') &&
    searchParams.get('token')
  ) {
    return null;
  }

  if (!dictionary) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F4EF]">
      <div className="max-w-[600px] text-center">
        <ErrorBg className="mb-4 inline-block" />
        <h2 className="mb-4 text-2xl font-semibold text-gray-600">
          {dictionary['500-标题']}
        </h2>
        <p className="mb-6 text-gray-500">
          {dictionary['500-描述']}
          <br />
          {dictionary['500-错误信息']}
          {errorMessage}
        </p>
        <div className="space-x-4">
          <Button onClick={() => reset()} variant="secondary" className="mr-1">
            {dictionary['重试']}
          </Button>
          {pathname !== `/home` && pathname !== `/zh/home` && (
            <Button onClick={() => redirect(`/${currentLanguage}/home`)}>
              {dictionary['返回首页']}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
